const mapping = {
    // Número máximo de níveis permitidos
    'MAX-LEVELS-ALLOWED': 30,
}

export default new class ConstantsService {

    /**
     * Retorna o valor de uma constante
     *
     * @param {string} key chave da constante
     */
    getConstant(key) {
        let value = mapping[key]

        if (!value)
            throw new Error(`Constant ${key} is not defined.`)

        return value
    }

}